function printDiv(elementId) {
  var print_style = document.getElementById('printing-css').value;
  var original_content = document.getElementById(elementId).innerHTML;
  window.frames["print_frame"].document.title = document.title;
  window.frames["print_frame"].document.body.innerHTML = '<style>' + print_style + '</style>' + original_content;
  window.frames["print_frame"].window.focus();
  window.frames["print_frame"].window.print();
}

jQuery(document).ready(function($) { 
  $('.active.js-accordion').addClass('show-accordion');
  $('.active.js-accordion.show-accordion').next().css("display", "inline");
$('.js-accordion').click(function (event) {
  event.preventDefault();
  if ($('.js-accordion').hasClass('show-accordion')) {
    $('.js-accordion').not($(this)).removeClass('show-accordion');
    $('.reveal-your-recipe__content-body').not($(this).next()).slideUp(300);
}
  $(this).toggleClass('show-accordion');
  $(this).next().slideToggle('slow');
}); 
});
